/** Mocked tagged template string to support lit-html syntax highlighting */
export function html(strings: any, ...values: any) {
  let str = ''
  strings.forEach((string: any, i: number) => {
    str += string + (values[i] || '')
  })

  // Remove whitespace from the start and end of the string.
  // This allows for easier spacing when writing templates.
  return str.trim()
}
